import React from 'react';
import { useCovidRegistration } from '../../../hooks/covid-registration';
import { UiIconMaterial, UiText, UiGrid } from '@open-stack/ui';
import { useToggle } from '../../../hooks/toggle';
import { XDrawerBottom } from '../../x/drawer-bottom/XDrawerBottom';
import moment from 'moment';
import styled from 'styled-components';
import { XCard } from '../../x/card/XCard';
import { XText, XTextType } from '../../x/text/XText';
import { XButton } from '@orderx/lab/ui';

const Wrapper = styled.div`
    color: var(--x-color-success) !important;
`;

const WrapperContainer = styled(XCard)`
    color: var(--x-color-success);
    text-align: center;
    font-size: var(--UiText-font-size-2);

    .UiIconMaterial {
        font-size: 5rem;
    }
`;

export function CovidNavTab() {
    const { lastRegistration } = useCovidRegistration();
    const [isOpen, toggleIsOpen] = useToggle();

    if (!lastRegistration) {
        return null;
    }

    return (
        <>
            <Wrapper onClick={toggleIsOpen} className="tab">
                <UiIconMaterial>verified_user</UiIconMaterial>
                <XText type={XTextType.LABEL}>Covid</XText>
            </Wrapper>

            {isOpen && (
                <XDrawerBottom onClose={toggleIsOpen} padding={2}>
                    <WrapperContainer>
                        <UiGrid padding={4} gap={4}>
                            <UiGrid>
                                <UiIconMaterial>check_circle</UiIconMaterial>

                                <UiText color="text-secondary">You are checked into:</UiText>

                                <UiText fontSize={8} weight={3}>
                                    {lastRegistration.outletName ||
                                        lastRegistration.locationName ||
                                        lastRegistration.zoneName ||
                                        '?'}
                                </UiText>
                            </UiGrid>

                            <UiText color="text-secondary" align="center" fontSize={1}>
                                <UiGrid gap={0}>
                                    <UiText>Last check-in time:</UiText>
                                    <UiText>{moment(lastRegistration.date).format('YYYY-MM-DD HH:mm')}</UiText>
                                </UiGrid>
                            </UiText>

                            <XButton onClick={toggleIsOpen}>Close</XButton>
                        </UiGrid>
                    </WrapperContainer>
                </XDrawerBottom>
            )}
        </>
    );
}
